// @flow
import { get } from 'lodash';


// eslint-disable-next-line
export function pathTemplate(string: string, context: Object, regex: RegExp = /{(.*?)}/g) {
    const matches = string.match(regex);
    if (matches) {
        let newString = string;

        matches.forEach((m: string) => {
            const path = m.replace('{', '').replace('}', '');
            newString = newString.replace(m, get(context, path, ''));
        });

        return newString;
    }

    return string;
}
